<template>
    <div class="container-fluid">
        <Breadcrumb title="SMTP Relay Groups" button-url="smtpRelayGroupCreate"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="isAdmin">
                                <treeselect placeholder="Search by owner"
                                            v-model="userSearch"
                                            :multiple="false"
                                            :options="userList"
                                            :load-options="loadUserList"
                                            value-format="object"
                                />
                            </div>
                            <input v-model="groupSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by group name">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="groupList.length > 0">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th v-if="isAdmin">Owner</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(group, index) in groupList" :key="index">
                                            <td class="align-middle">{{group.id}}</td>
                                            <td class="align-middle">{{group.name}}</td>
                                            <td class="align-middle" v-if="isAdmin">{{group.user.username}}</td>
                                            <td class="align-middle">
                                                <router-link :to="{ name: 'smtpRelayGroupEdit', params: { id: group.id }}"
                                                             class="btn btn-sm btn-info m-r-10">
                                                    <i class="fa fa-edit"></i> Edit
                                                </router-link>
                                                <router-link
                                                        :to="{ name: 'smtpRelayFilter2', params: { groupId: group.id }}"
                                                        class="btn btn-sm btn-warning m-r-10">
                                                    <i class="ti-server"></i> Relays
                                                </router-link>
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        @click="deleteGroup(group.id)">
                                                    <i class="fa fa-minus-circle"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate v-if="pageCount > 1"
                                          v-model="page"
                                          :page-count="pageCount"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="getItems"
                                          :prev-text="'Prev'"
                                          :next-text="'Next'"
                                          :container-class="'pagination justify-content-center'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import SmtpRelayGroupService from '../services/SmtpRelayGroupService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../services/UserService';

    export default {
        name: 'SmtpRelayGroups',
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                groupList: [],
                groupSearch: null,
                userList: null,
                userSearch: null,
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                isAdmin: false,
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
            this.getItems(this.page = 1);
        },
        methods: {
            getItems: function (pageNum) {
                this.loading = true;
                SmtpRelayGroupService.getGroups(pageNum, this.perPage, this.userSearch, this.groupSearch).then(response => {
                    this.groupList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            deleteGroup(id) {
                Swal({
                    title: 'Are you sure you want to delete this group?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return SmtpRelayGroupService.deleteGroup(id).then(() => {
                        }).catch(error => {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error!',
                                text: error.response.data.error
                            });
                            return false;
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Success',
                            `Group has been deleted.`,
                            'success'
                        );
                        this.getItems(this.page);
                    }
                })
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>